import type {
  IServiceForm,
  IJobAssociatedAssetUpdate,
  IService,
  IJobAssociatedMaintenanceType,
} from '@/interfaces'
import {
  JobAssociatedMaintenanceType,
  JobForm
} from '../jobs'
import { AssetType } from '@/enum'

class ServiceForm extends JobForm implements IServiceForm {
  asset: IJobAssociatedAssetUpdate

  maintenanceTypes: IJobAssociatedMaintenanceType[]

  constructor(service?: IService) {
    super(service)
    this.asset = {
      type: service?.asset?.assetType as AssetType,
      id:
        service?.asset?.assetType == AssetType.VEHICLE
          ? service?.asset?.vehicleId
          : service?.asset?.assetType == AssetType.MACHINE
            ? service?.asset?.machineId
            : (service?.asset?.equipmentId as string),
      vehicle: service?.asset?.vehicle,
      equipment: service?.asset?.equipment,
      machine: service?.asset?.machine
    }
    this.maintenanceTypes =
      service?.maintenanceTypes?.map(
        (maintenance: IJobAssociatedMaintenanceType) =>
          new JobAssociatedMaintenanceType({
            id: maintenance.type.id,
            workHours: maintenance.workHours || undefined,
            type: maintenance.type
          })
      ) ?? []
  }
}

export default ServiceForm
